// extracted by mini-css-extract-plugin
export default {"tv":"TV_tv__oZFNu","data":"TV_data__gUDkk","vote":"TV_vote__V5b7+"};